import React from "react";
import { useSearchParams } from "react-router-dom";

import { PlcControllersPage } from "./plc-controllers";
import { PlcEdgeRuntimesPage } from "./platform-edge-runtimes";

const VALID_VIEWS = new Set(["hosts", "controllers"]);

export function runtimeFleetViewFromSearch(search) {
  const params = new URLSearchParams(search || "");
  const view = params.get("view");
  return VALID_VIEWS.has(view) ? view : "hosts";
}

export function PlcRuntimeFleetPage({ routeSearch }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeView = runtimeFleetViewFromSearch(
    routeSearch == null ? `?${searchParams.toString()}` : routeSearch
  );
  const selectView = (view) => {
    const next = new URLSearchParams(searchParams);
    next.set("view", view);
    setSearchParams(next, { replace: true });
  };
  return (
    <div className="gwContentGrid plcRuntimeFleet">
      <section className="gwFormStack">
        <div className="gwPageHeader">
          <div>
            <div className="gwPageTitle">Runtimes</div>
            <div className="gwPageSubtitle">
              Connect and manage the Pis and industrial PCs that run PLC applications and I/O connections.
            </div>
          </div>
        </div>
        {activeView === "controllers" ? (
          <div className="gwNotice isSoft plcRuntimeAdvancedNotice">
            <div><strong>Advanced controller assignments</strong><span>Controller isolation, resource limits, and lifecycle reviews are engineering controls for applications already assigned to runtimes.</span></div>
            <button type="button" className="gwGhostBtn" onClick={() => selectView("hosts")}>Back to runtimes</button>
          </div>
        ) : null}
      </section>

      <div className="plcRuntimeFleetPanel">
        {activeView === "hosts"
          ? <PlcEdgeRuntimesPage embedded />
          : <PlcControllersPage embedded />}
      </div>

    </div>
  );
}
